module.exports = __webpack_public_path__ + "static/media/delevery.7c0d0203.svg";